export default __webpack_public_path__ + "687a4990ea22bb1a49d469a5d9319790.woff2";